<div class="d-flex flex-column align-items-center w-100">
<!-- <p-panel *ngIf="view_analize" i18n-header header="{{ 'header.analysis-configuration' | translate }}" class="custom-panel w-100">
    <div class="d-flex flex-row justify-content-evenly w-100 p-3 mt-4 mb-4">
      <div class="d-flex flex-column gap-3">
        <div class="d-flex align-items-center justify-content-between">
          <label id="startDateLabel" class="form-label mb-0 me-3 custom-label logistics-label">
            <strong>{{ 'analysis-configuration.time1' | translate }} (*)</strong>           
          </label>
          <p-spinner step="1" [(ngModel)]="time1" [min]="1"></p-spinner>
        </div>
  
        <div class="d-flex align-items-center justify-content-between">
          <label id="startDateLabel" class="form-label mb-0 me-3 custom-label logistics-label">
            <strong>{{ 'analysis-configuration.color1' | translate }} (*)</strong>
          </label>
          <p-colorPicker [(ngModel)]="color1" [inline]="true"></p-colorPicker>
        </div>
      </div>
  
      <div class="d-flex flex-column gap-3">
        <div class="d-flex align-items-center justify-content-between">
          <label id="startDateLabel" class="form-label mb-0 me-3 custom-label logistics-label">
            <strong>{{ 'analysis-configuration.time2' | translate }} (*)</strong>
          </label>
          <p-spinner step="1" [(ngModel)]="time2" [min]="1"></p-spinner>
        </div>
  
        <div class="d-flex align-items-center justify-content-between">
          <label id="startDateLabel" class="form-label mb-0 me-3 custom-label logistics-label">
            <strong>{{ 'analysis-configuration.color2' | translate }} (*)</strong>
          </label>
          <p-colorPicker [(ngModel)]="color2" [inline]="true"></p-colorPicker>
        </div>
      </div>
    </div>

</p-panel>
<p-panel *ngIf="view_attributes" i18n-header header="{{ 'navbar.attributes' | translate }}" class="w-100">
    <div class="d-flex flex-row justify-content-evenly w-100 p-3 mt-4 mb-4">
      <div class="col-md-6 d-flex flex-column gap-3">
        <div class="d-flex align-items-center ">
          <label id="startDateLabel" class="form-label mb-0 me-3 custom-label logistics-label text-align-right">
            <strong>{{ 'administration.attributes.automatepostalcode' | translate }}</strong>           
          </label>
          <p-checkbox binary="true" inputId="binary" [(ngModel)]="display"></p-checkbox>
        </div>
      </div>
        <div class="col-md-6 d-flex flex-column gap-3"></div>
  </div>
</p-panel> -->
<!-- PANEL 1: Análisis -->
<p-panel *ngIf="view_analize" i18n-header header="{{ 'header.analysis-configuration' | translate }}" class="custom-panel w-100">
  <div class="container mt-4 mb-4">
    <div class="row g-3">
      <!-- Columna 1 -->
      <div class="col-12 col-md-6">
        <div class="mb-2 row align-items-center">
          <label class="col-12 col-sm-5 col-form-label logistics-label">
            <strong>{{ 'analysis-configuration.time1' | translate }} (*)</strong>
          </label>
          <div class="col-12 col-sm-7">
            <p-spinner step="1" [(ngModel)]="time1" [min]="1"></p-spinner>
          </div>
        </div>

        <div class="mb-2 row align-items-center">
          <label class="col-12 col-sm-5 col-form-label logistics-label">
            <strong>{{ 'analysis-configuration.color1' | translate }} (*)</strong>
          </label>
          <div class="col-12 col-sm-7">
            <p-colorPicker [(ngModel)]="color1" [inline]="true"></p-colorPicker>
          </div>
        </div>
      </div>

      <!-- Columna 2 -->
      <div class="col-12 col-md-6">
        <div class="mb-2 row align-items-center">
          <label class="col-12 col-sm-5 col-form-label logistics-label">
            <strong>{{ 'analysis-configuration.time2' | translate }} (*)</strong>
          </label>
          <div class="col-12 col-sm-7">
            <p-spinner step="1" [(ngModel)]="time2" [min]="1"></p-spinner>
          </div>
        </div>

        <div class="mb-2 row align-items-center">
          <label class="col-12 col-sm-5 col-form-label logistics-label">
            <strong>{{ 'analysis-configuration.color2' | translate }} (*)</strong>
          </label>
          <div class="col-12 col-sm-7">
            <p-colorPicker [(ngModel)]="color2" [inline]="true"></p-colorPicker>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-panel>

<!-- PANEL 2: Atributos -->
<p-panel *ngIf="view_attributes" i18n-header header="{{ 'navbar.attributes' | translate }}" class="w-100">
  <div class="container mt-4 mb-4">
    <div class="row g-3">
      <div class="col-12 col-md-6">
        <div class="row align-items-center">
          <label class="col-12 col-sm-5 col-form-label logistics-label">
            <strong>{{ 'administration.attributes.automatepostalcode' | translate }}</strong>
          </label>
          <div class="col-12 col-sm-7">
            <p-checkbox binary="true" inputId="binary" [(ngModel)]="autoPC"></p-checkbox>
          </div>
        </div>
      </div>

      <!-- Segunda columna vacía para mantener estructura -->
      <div class="col-12 col-md-6"></div>
    </div>
  </div>
</p-panel>
<br/>

    <div class="d-flex justify-content-center w-100 mb-4">
        <button class="btn custom-button" (click)="saveChanges()">
            {{ 'general.update' | translate }}
        </button>
    </div>
  </div>